<section [ngClass]="dynamicClass">
  <div class="eq-container">
    <h2 class="eqtext-center eq-text-blue-darkBlue lg:eq-text-left eq-text-heading2-m lg:eq-text-heading2 eq-mb-[18px] lg:eq-mb-6 eq-font-bold" *scText="rendering.fields.Title"></h2>
    <div class="eq-flex eq-flex-col lg:eq-flex-row lg:eq-gap-[148px]">
      <div class="eq-w-full lg:eq-w-1/2 eq-flex eq-flex-col eq-gap-6">
        <div class="eq-text-body-m eq-text-[#67718D] lg:eq-text-body" *scText="rendering.fields.Subtitle"></div>
        <a *ngIf="rendering?.fields?.Link?.value?.href" class="eq-btn eq-btn-primary eq-w-full lg:eq-w-fit" hybridHref href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}">{{rendering?.fields?.Link?.value?.text}}</a>
      </div>
      <div class="eq-list-icon lg:eq-w-1/2 eq-text-blue-darkBlue eq-text-bullets-m lg:eq-text-bullets eq-mt-[44px] lg:eq-mt-0" *scRichText="rendering.fields.Text"></div>
    </div>
  </div>
</section>
